import { IMedia, Media } from './Media'

export const OrganizationRoles = ['admin', 'member'] as const
export const OrganizationType = [ 'place', 'event', 'group', 'individual', 'independant', 'other' ] as const
export const OrganizationPosition = ['director', 'community-manager', 'marketing', 'sales', 'event-manager', 'volunteer', 'other'] as const

export const OrganizationEntitlementTypes = [ 'pro' ] as const
export const OrganizationStatus = ['published', 'pending'] as const

export type OrganizationEntitlement = {
  id: string
  level: string
  type: typeof OrganizationEntitlementTypes[number]
  createdAt: Date
  expiresAt: Date | null
}

export interface IOrganization {
  _id: string
  
  name: string
  description: string
  logo: IMedia | null
  banner: IMedia | null

  status: typeof OrganizationStatus[number]
  images: IMedia[]

  type: typeof OrganizationType[number]
  email: string

  entitlements: OrganizationEntitlement[]
  entitlementCheckedAt: Date | null

  followerCount: number

  company: {
    name: string
    address: string
    city: string
    state: string
    country: string
    zipCode: string
    vat: string
  }

  squareId: string

  users: {
    _id: string
    role: typeof OrganizationRoles[number]
    position: typeof OrganizationPosition[number]
  }[]

  placesMax: number
  places: string[]

  certifiedAt: Date | null
  verifiedAt: Date | null
  inviteCode?: string

  // VIRTUALS

  isPro: boolean
  isEssential: boolean
  isAdvanced: boolean
}

export interface Organization extends IOrganization {}

export class Organization implements IOrganization {
  logo: Media
  banner: Media
  images: Media[]

  constructor(props: IOrganization) {

    Object.assign(this, {
      ...props,
      entitlements: (props.entitlements ?? []).map((entitlement) => ({
        ...entitlement,
        createdAt: new Date(entitlement.createdAt),
        expiresAt: entitlement.expiresAt ? new Date(entitlement.expiresAt) : null
      })),
      logo: props.logo ? new Media(props.logo) : null,
      banner: props.banner ? new Media(props.banner) : null,
      images: props.images.map((image) => new Media(image))
    })
  }

  public get isCertified () {
    return this.certifiedAt !== null
  }

  public get isVerified () {
    return this.verifiedAt !== null
  }
}